import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type CardCodeTemplateDb = {
  cardTemplateId: string;
  content: string;
}
const initial: CardCodeTemplateDb = {
  cardTemplateId: '',
  content: ''
};

export type CardCodeTemplateDbHashType = {
  [key in string]: CardCodeTemplateDb;
}

export type CardCodeTemplateAddPayload = {
  id?: string;
} & CardCodeTemplateDb;
export type CardCodeTemplateUpdatePayload = {
  id: string;
} & { [P in keyof CardCodeTemplateDb]?: CardCodeTemplateDb[P] };

export type CardCodeTemplateDbState = {
  cardCodeTemplates: CardCodeTemplateDbHashType;
}

export const generateCardCodeTemplateId = (): string => generateId('cct');
let initialState: CardCodeTemplateDbState = { cardCodeTemplates: {} };
const key = 'cardCodeTemplates';

const cardCodeTemplateDbSlice = createSlice({
  name: 'cardCodeTemplateDb',
  initialState,
  reducers: {
    initializeCardCodeTemplates(state: CardCodeTemplateDbState) {
      state.cardCodeTemplates = {};
    },
    addCardCodeTemplate(state: CardCodeTemplateDbState, action: PayloadAction<CardCodeTemplateAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateCardCodeTemplateId();
      state.cardCodeTemplates[id] = obj;
      saveData(key, id, obj);
    },
    updateCardCodeTemplate(state: CardCodeTemplateDbState, action: PayloadAction<CardCodeTemplateUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.cardCodeTemplates[id] === undefined) {
        console.log(`*** CardCodeTemplate not found: ${id}`);
      } else {
        const newData = { ...state.cardCodeTemplates[id], ...obj };
        state.cardCodeTemplates[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteCardCodeTemplate(state: CardCodeTemplateDbState, action: PayloadAction<CardCodeTemplateUpdatePayload>) {
      const id = action.payload.id;
      delete state.cardCodeTemplates[id];
      deleteData(key, id);
    },
    saveCardCodeTemplates(state: CardCodeTemplateDbState, action: PayloadAction<void>) {
      saveAllData(key, state.cardCodeTemplates);
    },
    signUpCardCodeTemplates(state: CardCodeTemplateDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.cardCodeTemplates, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: CardCodeTemplateDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.cardCodeTemplates = updatedValues;
      if (changed) saveAllData(key, state.cardCodeTemplates);
    })
  }
})

export const { initializeCardCodeTemplates, addCardCodeTemplate, updateCardCodeTemplate, deleteCardCodeTemplate, saveCardCodeTemplates, signUpCardCodeTemplates } = cardCodeTemplateDbSlice.actions;
export default cardCodeTemplateDbSlice.reducer;
